'use client'

import {
  Badge,
  Card,
  Col,
  Icon,
  type IconNames,
  Row,
  Typography,
} from '@repo/ui/components'
import { type MessagesKeys, useTranslate } from '@repo/shared/hooks'
import { Link } from '@repo/shared/i18n/navigation'
import { usePathname } from '@repo/shared/i18n/navigation'
import { cn } from '@repo/ui/lib/utils'
type MenuItem = {
  label: MessagesKeys
  icon?: IconNames
  activeIcon?: IconNames
  badge?: {
    text: MessagesKeys
    variant: 'liquid' | 'solid'
    count?: number
  }
  href: string
  disabled?: boolean
}

export const WalletDepositSidebarLayout = () => {
  const menuItems: MenuItem[] = [
    {
      label: 'walletDepositLayout_onlinePayment',
      // icon: 'UndefinedGhostLine',
      href: '/wallet/deposit/online-payment',
      disabled: false,
    },
    {
      label: 'walletDepositLayout_cardToCard',
      // icon: 'UndefinedGhostLine',
      badge: { text: 'walletDepositLayout_soon', variant: 'liquid' },
      href: '/wallet/deposit/card-to-card',
      disabled: true,
    },
    {
      label: 'walletDepositLayout_withNumber',
      // icon: 'UndefinedGhostLine',
      badge: { text: 'walletDepositLayout_soon', variant: 'liquid' },
      href: '/wallet/deposit/with-number',
      disabled: true,
    },
    {
      label: 'walletDepositLayout_accountToAccount',
      // icon: 'UndefinedGhostLine',
      badge: { text: 'walletDepositLayout_soon', variant: 'liquid' },
      href: '/wallet/deposit/account-to-account',
      disabled: true,
    },
    {
      label: 'walletDepositLayout_withCrypto',
      // icon: 'UndefinedGhostLine',
      // badge: { text: 'walletDepositLayout_soon', variant: 'liquid' },
      href: '/wallet/deposit/crypto',
      // disabled: true,
    },
  ]

  const { t } = useTranslate()
  const pathname = usePathname()

  return (
    <Col className='gap-md'>
      <Card>
        <Col className='gap-xs'>
          {menuItems.map((item, index) => {
            const isActive = pathname?.includes(item.href)
            return (
              <Row
                key={index}
                as={Link}
                href={item.href}
                className={cn(
                  'group border border-neutral-surface-5 cursor-pointer rounded-xs p-md',
                  item.disabled
                    ? 'opacity-50 cursor-not-allowed pointer-events-none'
                    : '',
                  isActive
                    ? 'bg-neutral-surface'
                    : 'bg-neutral-surface-light hover:bg-neutral-surface',
                )}
              >
                <Row className=' gap-md'>
                  {/* <Icon
                    name={item.icon}
                    size='sm'
                    color={
                      item.disabled
                        ? 'fill-neutral-surface-40'
                        : 'fill-neutral-surface-100'
                    }
                  /> */}
                  <Typography
                    size='sm'
                    weight='bold'
                    color={
                      item.disabled ? 'text-neutral-surface-40' : undefined
                    }
                  >
                    {t(item.label)}
                  </Typography>
                </Row>
                {item.badge && (
                  <Badge size='sm' variant={item.badge.variant} color='neutral'>
                    {item.badge.count && `${item.badge.count} `}
                    {t(item.badge.text)}
                  </Badge>
                )}

                <Icon
                  name='ChevronLeftLine'
                  size='sm'
                  color='fill-neutral-surface-20'
                  className={cn(isActive ? '' : 'hidden group-hover:block')}
                />
              </Row>
            )
          })}
        </Col>
      </Card>
    </Col>
  )
}
